import { useEffect } from 'react';

import useHistory from 'routing/useHistory';

import gmailRoutes from './common/Routes';

type GmailInputConfigurationProps = {
  url?: string;
};

// https://stackoverflow.com/questions/52912238/render-methods-should-be-a-pure-function-of-props-and-state
const GmailInputConfiguration = ({
  url = gmailRoutes.INTEGRATIONS.Gmail.ACTIVITYAPI.index,
}: GmailInputConfigurationProps) => {
  const history = useHistory();

  useEffect(() => {
    history.push(url);
  }, [history, url]);

  return null;
};

export default GmailInputConfiguration;
